package com.merkost.handpass.api.dto.listing

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ListingImageDto(
    val id: String,
    @SerialName("storage_url") val storageUrl: String,
    @SerialName("display_order") val displayOrder: Int,
)
